import $ from 'jquery';

$(document).ready(function() {
    var faqButton = $('.js-faq-submit');
    var faqForm = $('#FaqForm_FaqForm');
    if (faqButton) {
        faqButton.on('click', function (e) {
            if (faqForm) {
                e.preventDefault();
                faqForm.attr('novalidate');
                faqForm.submit();
                $.ajax({
                    type: 'POST',
                    url: $(this).attr('href'),
                    success: function (data) {
                        console.log('success');
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        console.log('error');
                    }
                });
            }
        })
    }

    let emptyDeleteButton = $('.js-faq-empty-delete-button');
    if (emptyDeleteButton) {
        emptyDeleteButton.each(function(i, obj){
            if ($(this).closest('.fieldgroup-field').prev().find('input').val()) {
                $(this).remove();
            }
        });
    }
});